export class CommonUtils {

    public static jsonClone<T>(obj: T, defaultValue: T | any = null): T {
        const newObj = obj ? JSON.parse(JSON.stringify(obj)) : (typeof defaultValue === 'function' ? defaultValue() : defaultValue);
        return newObj;
    }

    public static isNullOrUndefined<T>(obj: T | null | undefined): obj is null | undefined {
        return typeof obj === "undefined" || obj === null;
    }

    /**
     * add zeros before the string
     * @param num
     * @param size
     * @returns {string}
     */
    public static pad(num, size) {
        var s = "000000000" + num;
        return s.substr(s.length - size);
    }

    /**
     * "yyyy-mm-dd"
     * @param {string} yyyy_mm_dd
     * @returns {Date}
     */
    public static strToDateWithoutTime(yyyy_mm_dd: string): Date {
        const y = Number(yyyy_mm_dd.substr(0, 4));
        const m = Number(yyyy_mm_dd.substr(5, 2)) - 1;
        const d = Number(yyyy_mm_dd.substr(8, 2));
        const date = new Date(y, m, d);
        date.setHours(0,0,0,0);
        return date;
    }

    public static dateWithoutTime(date: string): string {
        let dateStr = date;
        if (!CommonUtils.isNullOrUndefined(date) && date !== '') {
            const dateVal = CommonUtils.parseBackendDate(date);
            dateStr = CommonUtils.pad(dateVal.getFullYear(), 4)
                + '-' + CommonUtils.pad(dateVal.getMonth() + 1, 2)
                + '-' + CommonUtils.pad(dateVal.getDate(), 2);
        }
        return dateStr;

    }

    /**
     *  Parse date string from back-end
     * @param {string} date - e.g. "2018-10-05T16:00:00.000+0000"
     * @returns {Date}
     */
    public static parseBackendDate(date: string) {
        // Note: using replace to fix it for Safari
        if (CommonUtils.isSafari()) {
            date = date.replace(/[.](.)*/,'');
        }
        // console.log('parseBackendDate:', date, 'Date:', new Date(Date.parse(date)));
        return new Date(Date.parse(date));
    }

    public static isSafari() : boolean {
        const ua = window.navigator.userAgent;
        const isChrome = ua.indexOf('Chrome/') > 0;
        const isSafari = !isChrome && (ua.indexOf('Safari/') > 0);
        // console.log('isSafari:', isSafari, 'isChrome:', isChrome);
        return isSafari;
    }

}
